export default {
  SIGN: 'sign',
  CONTRACT_DETAILS: 'contractDetails',
  INVOICE_DETAILS: 'invoiceDetails',
  PAY_NOW: 'payNow',
  REQUISITES: 'requisites',
  ADDITIONAL_DETAILS: 'additionalDetails',
  TRANSACTIONS: 'transactions'
}
